/* eslint-disable import/first */
import React, { useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
const { getClusterId } = Slices.configSlice;
const { fetchHome } = Slices.homeSlice;
import Cookies from 'js-cookie';
import css from './index.module.scss';

export default function OrderModeBanner({ widgetData = {}, imgBaseUrl }) {
  const { media: mediaList = [] } = widgetData;
  const dispatch = useDispatch();
  const home = useSelector((state) => state.home);
  const menuState = useSelector((state) => state.menu);
  const config = useSelector((state) => state.config);
  const clusterId = useSelector(getClusterId);

  useEffect(() => {
    if (
      config.status === 'succeeded' &&
      home.status === 'idle' &&
      menuState.status === 'succeeded'
    ) {
      const homePayload = {
        cluster: clusterId,
      };
      dispatch(fetchHome(homePayload));
    }
    //  dispatch(fetchHome(blobURL));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [home.status, config.status, menuState.status]);
  return (
    <div className={css.root}>
      {mediaList?.map((media) => (
        <div className={css.mediaTile} key={`media-${media.sequence}-${media.mediaUrl}`}>
          <div className={css.media}>
            <img src={`${media.mediaUrl}`} alt="" />
          </div>
          {media.title ? <div className={css.title}>{media.title}</div> : ''}
          {media.ribbonUrl && (
            <div className={css.ribon}>
              <img src={`${media.ribbonUrl}`} alt="" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
